<template>
  <div>
    <!--加入我們-->
    <Join_1 v-if="isSubmit=== false"/>
    <!--填寫表單-->
    <Join_2 v-if="isSubmit=== false" @submit="clickSubmit"/>
    <!--加盟流程-->
    <Join_3 v-if="isSubmit=== false"/>
    <!--加盟優勢-->
    <Stage_6 v-if="isSubmit=== false" :show-join="false"/>
    <Join_4 v-if="isSubmit"/>
    <Loading/>
  </div>
</template>

<script>


import Stage_6 from "./home/Stage_6";
import Join_1 from "./join/Join_1";
import Join_2 from "./join/Join_2";
import Join_3 from "./join/Join_3";
import Join_4 from "./join/Join_4";
import Loading from "./dialog/Loading";

export default {
  name: "Join",
  components: {Join_1, Join_2, Join_3, Stage_6, Join_4, Loading},
  data() {
    return {
      isSubmit: false,
    };
  },
  methods: {
    clickSubmit() {
      this.isSubmit = true;
    }
  }
}
</script>

<style scoped>

</style>
